import { render, staticRenderFns } from "./NotFoundContainer.vue?vue&type=template&id=40f24a12&scoped=true"
import script from "./NotFoundContainer.vue?vue&type=script&lang=ts"
export * from "./NotFoundContainer.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundContainer.vue?vue&type=style&index=0&id=40f24a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f24a12",
  null
  
)

export default component.exports